import { render, staticRenderFns } from "./ResourceManager.vue?vue&type=template&id=684b8cfb&scoped=true"
import script from "./ResourceManager.vue?vue&type=script&lang=js"
export * from "./ResourceManager.vue?vue&type=script&lang=js"
import style0 from "./ResourceManager.vue?vue&type=style&index=0&id=684b8cfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684b8cfb",
  null
  
)

export default component.exports